<template>
  <div class="Notice">
    <base-header v-if="showType" activeIndex="0" />

    <div :class="showType ? 'banner__layer' : 'banner__layer bannerss'">

      <img class="banner-img" src="@/assets/imgs/about/banner.png" />
      <img class="banner-imgs" src="@/assets/imgs/about/wap/banner.png" />

      <div :class="showType ? 'banner-content content-box' : 'banner-content content-box banner-co'">
        <h1 class="title">稳健企业 焕发新生</h1>
        <h1 class="titles">稳健企业 </h1>
        <h1 class="titles"> 焕发新生</h1>
        <p class="banner-content-intro">香港黄金交易所AA类行员（081号）</p>
        <div class="banner-content-download">
          <router-link to="/Appdownload?key=1">
            <span class="banner-content-download-btn">APP下载</span>
          </router-link>
          <div class="banner-content-download-text">
            <div>
              <img src="@/assets/imgs/about/mobie-icon.png" alt="">
              <span>
                支持多平台 <br />
                双端互通
              </span>
            </div>
            <div>
              <img src="@/assets/imgs/about/user-black-icon.png" alt="">
              <span>
                简单 <br />
                易用
              </span>
            </div>
          </div>
        </div>
      </div>

    </div>
    <tit-vue :titleContent="changeTitle.titleTxt1"></tit-vue>
    <img class="loading" v-if="loading == true" src="../../static/common/loading.png" alt="">
    <ul class="noticeBox">
      <li @mouseover="mouseoverli" @mouseleave="mouseleaveli" @click="clickNotice(item.id)" v-for="item in noticeData"
        :key="item.id" :class="control ? 'mouse' : ''" style="animation-duration: 500ms">
        <div>
          <p class="circle">
            <span></span>
            <span>{{ item.title }}</span>
          </p>
          <p class="nTitle">
            <span>{{ item.dt }}</span>
            <img src="../../static/aboutus/right.png" alt="">
          </p>
        </div>
      </li>
    </ul>
    <button @click="moreNotice">
      <span>更多</span>
      <img src="../../static/market/more.png" alt="">
    </button>
    <base-footer v-if="showType"  />

  </div>
</template>

<script>
import TitVue from '../component/index/tit.vue';
import BaseHeader from '@/component/base-header';
import BaseFooter from '@/component/base-footer';
import { postCmsSystemRelay } from '@/apis/transfer';
import { getDatas } from '@/apis/hdtime'

export default {
  name: 'Notice',
  components: {
    TitVue,
    BaseHeader,
    BaseFooter
  },
  data() {
    return {
      changeTitle: {
        titleTxt1: ['平台公告', false],
      },
      // 数据
      noticeData: [],
      control: false,
      // 接口参数
      attr: {
        pageIndex: 0,
        pageSize: 5,
      },
      attr: {

        "type": 0,
        "pi": 1,
        "ps": 5,
        "tc": 0


      },
      loading: true,
      showType: true
    }
  },
  created() {
    if (this.$route.query.from) {
      this.showType = false

    };
    // 传参控制显示顶部和底部
    this.$emit('controlShow', false);
    this.init(this.attr, 0);
  },
  methods: {
    // 初始化数据
    init(attr, key) {
      postCmsSystemRelay('noticeListApi', attr).then(res => {
        if (res.data == 0) {
          this.loading = false;
          if (key == 1) {
            this.noticeData = [...this.noticeData, ...res.lst];
          } else {
            this.noticeData = res.lst
          }
        }
      }).catch(err => {
        
      })

  
    },
    // 鼠标移入事件
    mouseoverli(event) {
      let _el = event.currentTarget;
      if (_el.getAttribute('class') === 'mouse') {
        _el.setAttribute('class', '');
      } else {
        _el.setAttribute('class', 'mouse');
      }
    },
    // 鼠标移出事件
    mouseleaveli(event) {
      let _el = event.currentTarget;
      _el.setAttribute('class', '');
    },
    // 获取更多资讯
    moreNotice() {
      if (this.attr.ps == 5) {
        this.attr.pi = 1;
        this.attr.ps = 10;
        this.init(this.attr, 0);
      } else {
        this.attr.pi++;
        this.init(this.attr, 1);
      }
    },
    // 点击跳转平台公告详情页 
    clickNotice(attr) {
      let routeData = this.$router.resolve({
        name: "NoticeDetails",
        query: {
          id: attr
        }
      });
      window.open(routeData.href, '_blank');
    }
  }
}
</script>

<style lang="less" scoped>
.Notice {
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;

  // align-items: center;
  .loading {
    margin: 0 auto 30px;
    width: 50px;
  }

  .banner__layer {
    position: relative;
    padding-top: 80px;

    .banner-img {
      width: 100%;
      display: block;
    }

    .banner-imgs {
      display: none;
      width: 100%;
      height: auto;
    }

    .banner-content {
      position: absolute;
      top: 50%;
      left: 30%;
      transform: translate(-50%, -50%);
      z-index: 11;
      color: #FFFFFF;

      .title {
        display: block;
      }

      .titles {
        display: none;
      }

      h1 {
        font-size: 68px;
        margin: 0;
      }

      &-intro {
        font-size: 18px;
      }

      &-download {
        display: flex;
        align-items: center;
        margin-top: 50px;

        &-btn {
          width: 198px;
          line-height: 56px;
          color: #FFFFFF;
          background: #FA2314;
          border-radius: 4px;
          margin-right: 10px;
          cursor: pointer;
          text-align: center;
          font-size: 20px;
          font-weight: 700;
          display: inline-block;
        }

        &-text {
          display: flex;
          align-items: center;

          >div {
            display: flex;
            align-items: center;
            color: #FFFFFF;
            padding: 4px 40px;

            &:first-child {
              border-right: 1px solid #0F0F11;
            }

            img {
              width: 38px;
              height: 38px;
              margin-right: 12px;
            }
          }
        }
      }
    }
  }

  .noticeBox {
    width: 1416px;
    margin: 0 auto;

    li {
      width: 100%;
      height: 100px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
      padding: 0 32px;
      box-shadow: 0px 0px 95px 0px rgba(43, 53, 105, 0.1);
      margin-bottom: 30px;
      cursor: pointer;

      div {
        width: 100%;
        height: 100px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .circle {
          display: flex;
          justify-content: center;
          align-items: center;

          span:nth-child(1) {
            display: inline-block;
            width: 10px;
            height: 10px;
            background-color: #333333;
            border-radius: 50%;
            margin-right: 15px;
          }
        }

        .nTitle {
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            width: 36px;
            margin-left: 15px;
            opacity: 0;
          }
        }
      }
    }
  }

  .mouse {

    // animation-duration: 500ms;
    div {
      border-bottom: 1px solid #db3d4c;
      transition: all 0.3s;

      .circle {
        span:nth-child(1) {
          background-color: #db3d4c !important;
          transition: all 0.3s;
        }
      }

      .nTitle {
        img {
          width: 36px !important;
          opacity: 1 !important;
          transition: all 0.3s;
        }
      }

      span {
        color: #db3d4c;
        transition: all 0.3s;
      }
    }
  }

  button {
    width: 195px;
    height: 60px;
    border-radius: 5px;
    background-color: #db3d4c;
    border: none;
    margin: 32px auto 110px;
    cursor: pointer;

    span {
      color: #ffffff;
      margin-right: 5px;
    }

    img {
      width: 10px;
      height: auto;
    }
  }
}

@media screen and (max-width: 500px) {
  .Notice {
    width: 100%;
    margin: 0 auto;

    .banner__layer {

      padding-top: 45px;

      .banner-img {
        display: none;
      }

      .banner-imgs {
        display: block;
        height: 500px;

      }

      .banner-content {
        position: absolute;
        top: 37%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 11;
        padding-top: 40px;
        background: linear-gradient(180deg, #100005 68.28%, rgba(24, 24, 24, 0) 100%);
        // color: #000;
        color: #FFFFFF;

        .title {
          display: none;
        }

        .titles {
          color: #FFFFFF;
          display: block;
          white-space: nowrap;
        }

        h1 {
          font-size: 58px;
          line-height: 77px;
          margin: 0;
          width: 100%;
          text-align: center;
          white-space: wrap;
        }

        &-intro {
          font-size: 14px;
          text-align: center;
        }

        &-download {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-top: 20px;

          &-btn {
            width: 180px;
            line-height: 34px;
            color: #FFFFFF;
            background: #FA2314;
            border-radius: 4px;
            margin-right: 10px;
            cursor: pointer;
            text-align: center;
            font-size: 14px;
            font-weight: 700;
            margin-bottom: 20px;
          }

          &-text {
            display: flex;
            align-items: center;

            >div {
              display: flex;
              align-items: center;
              color: #0F0F11;
              color: #FFFFFF;

              padding: 2px 20px;
              font-size: 10px;

              &:first-child {
                border-right: 1px solid #fff;
              }

              img {
                width: 24px;
                height: 24px;
                margin-right: 12px;
              }
            }
          }
        }
      }
            .banner-co {
              top: 33%;
            }
    }
 .bannerss {
   padding-top: 0;
 }
    .content-box {
      width: 100%;
      margin: auto;
      box-sizing: border-box;
    }
    
    .noticeBox {
      width: 100%;
      box-sizing: border-box;
      padding: 0 5px;

      li {
        box-sizing: border-box;
        height: 70px;
        padding: 0 10px 0 10px;
        margin-bottom: 10px;

        div {
          .circle {
            span:nth-child(1) {
              width: 4px;
              height: 4px;
            }

            span {
              font-size: 14px;
            }
          }

          .nTitle {
            span {
              font-size: 12px;
              width: 70px;
              text-align: center;
            }
          }
        }
      }
    }

    .mouse {
      div {
        border-bottom: none !important;
        transition: none;

        .circle {
          span:nth-child(1) {
            background-color: #333333 !important;
            transition: none;
          }
        }

        .nTitle {
          img {
            display: none !important;
            transition: none;
          }
        }

        span {
          color: #333333;
          transition: none;
        }
      }
    }

    button {
      width: 140px;
      height: 40px;
      border-radius: 5px;
      background-color: #db3d4c;
      border: none;
      margin: 22px auto 50px;
      cursor: pointer;

      span {
        font-size: 14px;
        color: #ffffff;
        margin-right: 5px;
      }

      img {
        width: 10px;
        height: auto;
      }
    }
  }
}
</style>
